/* assets/sections-boot.js */
(function () {
  if (window.__SECTIONS_BOOT_READY__) return;
  window.__SECTIONS_BOOT_READY__ = true;

  function initSection(wrapper) {
    if (!wrapper) return;
    const moduleName = wrapper.getAttribute('data-module');
    if (!moduleName) return;

    // Evitar doble init por sección
    if (wrapper.__modInited) return;
    // Si no hay aún init, encola
    // Cola interna del boot
window.__SectionQueue = window.__SectionQueue || {};
function enqueue(moduleName, el) {
  (window.__SectionQueue[moduleName] = window.__SectionQueue[moduleName] || []).push(el);
}
function flush(moduleName) {
  const fn = window.__SectionRegistry[moduleName];
  if (!fn || !window.__SectionQueue[moduleName]) return;
  let w;
  while ((w = window.__SectionQueue[moduleName].shift())) {
    try { fn(w); } catch (e) { console.error(`[${moduleName}] init error:`, e); }
  }
}

// En tu initSection():
if (!window.__SectionRegistry[moduleName]) {
  enqueue(moduleName, wrapper);
  return;
}

// Al final del archivo, después de definir scanAll():
// Cuando un módulo se registre más tarde, que pueda vaciar la cola:
window.__flushSectionQueue = flush;
    wrapper.__modInited = true;

    try {
      const init = window.__SectionRegistry[moduleName];
      const cleanup = init(wrapper) || null;
      // Guarda cleanup para cuando el editor la quite
      wrapper.__modCleanup = cleanup;
    } catch (err) {
      console.error(`[${moduleName}] init error:`, err);
    }
  }

  function scanAll() {
    document.querySelectorAll('[data-module]').forEach(initSection);
  }

  // DOM listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  // Editor de Shopify
  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target) return;
    const s = e.target.querySelector('[data-module]') ? e.target : null;
    if (s) initSection(s);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (!e.target) return;
    const s = e.target.querySelector('[data-module]') ? e.target : null;
    if (s && s.__modCleanup) {
      try { s.__modCleanup(); } catch(_){}
      s.__modCleanup = null;
      s.__modInited = false;
    }
  });

  // (Opcional) Observa DOM dinámico fuera del editor
  const mo = new MutationObserver((mList) => {
    for (const m of mList) {
      m.addedNodes && m.addedNodes.forEach((n) => {
        if (!(n instanceof Element)) return;
        if (n.hasAttribute && n.hasAttribute('data-module')) initSection(n);
        n.querySelectorAll && n.querySelectorAll('[data-module]').forEach(initSection);
      });
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();